var busy = false;
var productfinderRequestTimer = null;
var productfinderClient = null;

/*trigger*/
$( document ).ready(function() {

});


$('section.finder input').bind("change",function (){
    clearTimeout(productfinderRequestTimer);
    productfinderRequestTimer = setTimeout(requestProducts, 400);
});
$('section.finder .find').bind("click",function (){
    clearTimeout(productfinderRequestTimer);
    requestProducts();
});

/*anonymous browser id*/
function getProductfinderClient(){
    if(productfinderClient){
        return productfinderClient;
    }

    var storageKey = 'holzwelten_productfinder_client';
    try {
        productfinderClient = window.localStorage.getItem(storageKey);
    } catch (error) {
        productfinderClient = null;
    }

    if(!productfinderClient){
        if(window.crypto && typeof window.crypto.randomUUID === 'function'){
            productfinderClient = window.crypto.randomUUID();
        }else{
            productfinderClient = Date.now().toString(36) + '-' +
                Math.random().toString(36).substring(2) +
                Math.random().toString(36).substring(2);
        }

        try {
            window.localStorage.setItem(storageKey, productfinderClient);
        } catch (error) {
            /*the id remains valid for the current page view*/
        }
    }

    return productfinderClient;
}

/*request products*/
function requestProducts(){

    if(!busy){

        /*get busy*/
        busy = true;

        /*reset*/
        $('.teaser.results').html('<section class="text center"><p>Produkte werden gesucht...</p></section>');

        /*get*/
        var tags = [];
        $(".tag:checked").each(function(){
            tags.push($(this).val());
        });
        var filter = {
            age: $(".age").val(),
            space: $(".space").val(),
            budget: $(".budget").val(),
            width: $(".width").val(),
            depth: $(".depth").val(),
            tags: tags.join(",")
        };

        /*post*/
        $.ajax({
            type: 'POST',
            url: './theme/public/assets/handler/productfinder.php',
            data: {
                filter: JSON.stringify(filter),
                client: getProductfinderClient()
            },
            success: function(response) {

                /*response*/
                var target = $('.teaser.results');
                if(response != 'null'){
                    target.html(response);
                }else{

                }

                if(tracking){
                    gtag('event','finder_use');
                    console.log('event sent');
                }

                /*things done*/
                busy = false;

            }
        });

    }

};
